/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal Pre-Auth
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PreAuthConfig } from '../model';
/**
 * PreApi - axios parameter creator
 * @export
 */
export const PreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get portal config options
         * @summary Get portal config options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreConfig: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/pre/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreApi - functional programming interface
 * @export
 */
export const PreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreApiAxiosParamCreator(configuration)
    return {
        /**
         * Get portal config options
         * @summary Get portal config options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreConfig(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreAuthConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PreApi - factory interface
 * @export
 */
export const PreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreApiFp(configuration)
    return {
        /**
         * Get portal config options
         * @summary Get portal config options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreConfig(options?: any): AxiosPromise<PreAuthConfig> {
            return localVarFp.getPreConfig(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreApi - object-oriented interface
 * @export
 * @class PreApi
 * @extends {BaseAPI}
 */
export class PreApi extends BaseAPI {
    /**
     * Get portal config options
     * @summary Get portal config options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreApi
     */
    public getPreConfig(options?: any) {
        return PreApiFp(this.configuration).getPreConfig(options).then((request) => request(this.axios, this.basePath));
    }
}
